import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../../actions/reportAction';
import * as orderAction from './../../../../../../actions/orderAction';
import OrderDetailReportsByHotel from './OrderDetailReportsByHotel';

const mapStateToProps = state => {
    return {
        reportState: state.reportReducer,
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSaleDetailReportByHotel: (filters) => dispatch(reportAction.getSaleDetailReportByHotel(filters)),
        exportHotelSaleDetailExcel: filters => dispatch(orderAction.exportHotelSaleDetailExcel(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderDetailReportsByHotel));
